/*
 Browse

 Rezerwacje - z wykorzystaniem Redux (implementacja w appredux)
 Stan nawigacji: (store.pageState)
 Wywołanie akcji: ??store.dispatch(??
   Actions.nazwaAkcj(<parametry>));

 do zrobienia:
  - logowanie

 historia: 
  04-2019 JW - start
  03-05-2019 - połączenie z Redux
  20-05-209 - materialize
*/

import * as React from "react";

import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import CardMedia from '@material-ui/core/CardMedia';
import { Grid, Fab } from '@material-ui/core';

import { AppState, Actions, store, DisplayState, IPageState } from 'appredux';

import { connect } from 'react-redux';


//import { Kontakt, hotelService, PortalInfo, AsortMenuWiersze, AsortMenuWiersz, AsortGrupyWiersz, WWWSprzedazInfo } from '../api';
//import { MenuService, RestaurantService } from '../api';

import { Trans, WithTranslation, withTranslation } from 'react-i18next';

import MainPage from "./MainPage";


//import { mobileBreakpoint } from './common/formFields/formularzStaleWspolne';



interface MainProps {

 page: IPageState
}

interface MainState {

  width: number,
}


class Main extends React.Component<WithStyles<typeof styles> & MainProps & WithTranslation, MainState>  {

    constructor(props: WithStyles<typeof styles> & MainProps & WithTranslation) {
        super(props, {});

        this.state = {

            width: window.innerWidth,
        }
    }

    async componentDidMount() {
        this.updateWindowWidth();
        window.addEventListener('resize', this.updateWindowWidth);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowWidth);
    }


    updateWindowWidth = () => {
        this.setState({ ...this.state, width: window.innerWidth });
    }


    render = () => {
        const { classes } = this.props;

        let display = this.props.page.displayState

        //console.log(display)

        let userData = this.props.page.userDataClient.telefon !== "" ? this.props.page.userDataClient : undefined

        return (
            <Grid container className={classes.container} >

            {
                display === DisplayState.logowanie ? <MainPage windowWidth={this.state.width}/> : null 
            }

                {/* <NavBar user={userData}/> */}
               
            {/* {
                display === DisplayState.start ? <StronaGlowna windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.logowanie ? <Login /> : null 
            }

            {
                display === DisplayState.obiektyMenu ? <ObiektyMenu/> : null 
            }

            {
                display === DisplayState.obiekty ? <Obiekty/> : null 
            }

            {
                display === DisplayState.zamkiMenu ? <ZamkiMenu/> : null 
            }

            {
                display === DisplayState.zamkiZamki ? <Zamki windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.zamkiPasscode ? <Hasla windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.zamkiZamkiHasla ? <ZamekIHasla windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.zamkiKodowanie ? <Kodowanie windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.adminMenu ? <AdminMenu/> : null 
            }

            {
                display === DisplayState.adminDane ? <AdminDane windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.adminTwojeKonto ? <AdminTwojeKonto windowWidth={this.state.width}/> : null 
            }
            {
                display === DisplayState.kodyBledow ? <KodyBledow/> : null 
            }


            {
                display === DisplayState.zamkiZamki ||
                display === DisplayState.zamkiPasscode ||
                display === DisplayState.zamkiZamkiHasla ||
                display === DisplayState.zamkiKodowanie ||
                display === DisplayState.adminDane ||
                display === DisplayState.adminTwojeKonto ||
                display === DisplayState.kodyBledow ? <LogoFooter/> : null 
            } */}


            {/* {
                display === DisplayState.rozliczeniaMenu ? <Rozliczenia/> : null 
            }

            {
                display === DisplayState.rozliczeniaTwojeZaplaty ? <TwojeZaplaty windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.rozliczeniaTwojeDostawy ? <TwojeDostawy windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.rozliczeniaTwojeKonto ? <TwojeKonto windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.rozliczeniaZalogaZaplaty ? <ZalogaZaplaty windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.rozliczeniaZalogaDostawy ? <ZalogaDostawy windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.rozliczeniaZalogaKonta ? <ZalogaKonta windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.naszeOddzialy ? <NaszeOddzialy windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.naszOddzial ? <NaszOddzial windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.naszaFirma ? <NaszaFirma windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.wywozMenu ? <WywozMenu /> : null 
            }

            {
                display === DisplayState.wywoz ? <Wywoz windowWidth={this.state.width} zamOsobaId="1" zamFirmaId="1"/> : null 
            }

            {
                display === DisplayState.wywozAsortyment ? <Asortyment windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.wywozOddzialOsoby ? <OddzialOsoby windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.wywozTwojeKonto ? <WywozTwojeKonto windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.wywozZalogaKonta ? <WywozZalogaKonta windowWidth={this.state.width}/> : null 
            }

            {
                display === DisplayState.platnosc ? <WorkInProgress/> : null 
            } */}

            </Grid>
        )
    }
}


// połączenie z Redux
const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
});

const styles = (theme: Theme) => ({
    container: {
        margin: "0em auto",
        //paddingTop: "2em",
        padding: '0em',
        width: "100%",
        //maxWidth: "1340px",
        maxWidth: "80%",
        //minHeight: "95vh"
        "@media screen and (min-width: 1000px)": {
            //maxWidth: "60%",
            maxWidth: "700px",
          }
      },

});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Main)));
